export enum UnitTypes {
  KG,
  KWH,
  KG_H,
  KWH_H,
}
